module.exports = __webpack_public_path__ + "img/iconoqr.606c2fd9.png";